<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Create Event</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/events" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createEvent" v-if="event">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="event.title"
                                          label="Event Title"
                                          placeholder="Enter Event Title"
                                          v-validate="rules.title"
                                          data-vv-name="title"
                                          cus-name="title"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-4" v-if="type.length">
                                <fg-select
                                        v-model="event.type"
                                        label="Type"
                                        v-validate="rules.type"
                                        data-vv-name="type"
                                        cus-name="type"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="type"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="event.tags"
                                          label="Event Tags"
                                          placeholder="Enter Comma separated Tags"
                                          v-validate="rules.tags"
                                          data-vv-name="tags"
                                          cus-name="tags"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <label>Start Date</label>
                                <datetime v-model="startDate"
                                          input-class="form-control"
                                          placeholder="Choose a Date"
                                          type="datetime"
                                          :min-datetime="startDate"
                                          input-format="DD-MM-YYYY HH:mm"
                                          auto-continue>

                                </datetime>
                            </div>
                            <div class="col-4">
                                <label>End Date</label>
                                <datetime v-model="endDate"
                                          input-class="form-control"
                                          placeholder="Choose a Date"
                                          type="datetime"
                                          input-format="DD-MM-YYYY HH:mm"
                                          auto-continue>

                                </datetime>
                            </div>
                            <div class="col-4">
                                <fg-input type="number"
                                          v-model="event.duration"
                                          label="Event Duration"
                                          placeholder="Enter Event Duration"
                                          v-validate="rules.duration"
                                          data-vv-name="duration"
                                          cus-name="duration"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="event.description"
                                        label="Event Description"
                                        placeholder="Enter Event Description"
                                        v-validate="rules.description"
                                        data-vv-name="description"
                                        cus-name="description"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-md-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="event.longDescription"
                                        label="Long Description"
                                        placeholder="Enter Event Long Description"
                                        v-validate="rules.longDescription"
                                        data-vv-name="Long Description"
                                        cus-name="Long Description"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-md-12">
                                <fg-image type="file"
                                          v-on:file="updateValue"
                                          v-model="event.img_url"
                                          label="Event Image"
                                          placeholder="Enter Comma separated Tags"
                                          v-validate="rules.img_url"
                                          data-vv-name="event image"
                                          cus-name="event image"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-image>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="event.authBannerText"
                                        label="Auth Banner"
                                        placeholder="Enter Auth Banner Text"
                                        v-validate="rules.authBanner"
                                        data-vv-name="authBanner"
                                        cus-name="authBanner"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="event.unAuthBannerText"
                                        label="Unauth Banner"
                                        placeholder="Enter Unauth Banner Text"
                                        v-validate="rules.unAuthBanner"
                                        data-vv-name="unAuthBanner"
                                        cus-name="unAuthBanner"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                            <fg-input type="text"
                                      v-model="event.jw_stream_title"
                                      label="Video Code"
                                      placeholder="Enter Video Code"
                            >
                            </fg-input>
                          </div>
                            <div v-if="event.type == '1' || !event.type" class="col-4">
                                <fg-input type="text"
                                          v-model="event.jw_rtmp_url"
                                          label="JW RTMP URL"
                                          placeholder="Enter JW RTMP URL">
                                          <!--v-validate="rules.jw_rtmp_url"-->
                                          <!--data-vv-name="jw_rtmp_url"-->
                                          <!--cus-name="jw_rtmp_url"-->
                                          <!--:has-errors="errors"-->
                                          <!--:is-fields="fields"-->
                                </fg-input>
                            </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="event.chatroll_event_name"
                                          label="Chat Roll Event Name"
                                          placeholder="Enter Chat Roll Event Name"
                                          v-validate="rules.chatroll_event_name"
                                          data-vv-name="chatroll_event_name"
                                          cus-name="chatroll_event_name"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-12" v-if="experts.length">
                            <multiselect
                              v-model="event.csvExpertsIds"
                              placeholder="Select Expert(s)"
                              :multiple="true"
                              :options="experts.map(type => type.expertId)"
                              :custom-label="opt => experts.find(x => x.expertId == opt).name"
                              required>
                              >
                            </multiselect>
                          </div>
<!--                            <div class="col-4" v-if="experts.length">-->
<!--                                <fg-select-->
<!--                                        v-model="event.expertId"-->
<!--                                        label="Expert ID"-->
<!--                                        v-validate="rules.expertId"-->
<!--                                        data-vv-name="expertId"-->
<!--                                        cus-name="expertId"-->
<!--                                        :has-errors="errors"-->
<!--                                        :is-fields="fields"-->
<!--                                        :list="experts"-->
<!--                                        selectedKey="expertId"-->
<!--                                        >-->
<!--                                </fg-select>-->
<!--                            </div>-->
                          <div class="col-4">
                            <fg-input type="number"
                                      v-model="event.eventSwitchTime"
                                      label="Switch Time (Minutes)"
                                      placeholder="Enter Switch Time (Optional)"
                            >
                            </fg-input>
                          </div>
                          <div class="col-4" v-if="corporations.length">
                            <fg-select
                              v-model="event.corporationId"
                              label="Corporation (Optional)"
                              :list="corporations"
                              selectedKey="corporationId"
                            >
                            </fg-select>
                          </div>
                          <div class="col-4" v-if="eventType.length">
                            <fg-select
                              v-model="event.isPrivate"
                              label="Event Visibility"
                              v-validate="rules.isPrivate"
                              data-vv-name="Event Visibility"
                              cus-name="Event Visibility"
                              :has-errors="errors"
                              :is-fields="fields"
                              :list="eventType"
                              selectedKey="id"
                            >
                            </fg-select>
                          </div>
                          <div class="col-4">
                            <fg-input type="text"
                                      v-model="event.corporateEventArchive"
                                      label="Enable Corporate Archive"
                                      placeholder="0 or 1, 1 if true"
                                      :is-fields="fields">
                            </fg-input>
                          </div>
                            <div class="col-4" v-if="status.length">
                                <fg-select
                                        v-model="event.status"
                                        label="Status"
                                        v-validate="rules.status"
                                        data-vv-name="status"
                                        cus-name="status"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="status"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any() || (!event.csvExpertsIds || event.csvExpertsIds.length === 0)" class="btn btn-primary btn-fill btn-block">
                            Create Event
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'CreateEvent',
        created (){
    },
    data () {
        let dateTime = new Date();
        return {
            startDate: dateTime.toISOString(),
            endDate: new Date(dateTime.setHours(dateTime.getHours() + 1)).toISOString(),
            newImage: [],
            event: {
//                title: 'Test Admin API For insert 1',
                title: '',
//                description: 'She is an expert in working memory,',
                description: '',
                longDescription: '',
//                longDescription: 'She is an expert in working memory,',
                start_date: '',
                end_date: '',
                duration: '',
//                duration: '60',
//                img_url: 'http://content.jwplatform.com/thumbs/KOgteXrj-1280.jpg',
                img_url: '',
                tags: '',
//                tags: 'work',
//                 expertId: '',
              csvExpertsIds: null,
//                expertId: 2,
                authBannerText: '',
//                authBannerText: 'i am banner text',
                unAuthBannerText: '',
//                unAuthBannerText: 'I am going to be displayed',
                jw_stream_title: '',
//                jw_stream_title: 'First Tone Live',
                jw_rtmp_url: '',
//                jw_rtmp_url: 'https://content.jwplatform.com/players/a074QrQx-c398nk2E.html',
                chatroll_event_name: '',
//                chatroll_event_name: 'https://chatroll.com/embed/chat/tone-live?id=AhTHqT23gdJ&platform=html',
                type: '',
//                type: '1',
                status: '',
              eventSwitchTime: 0,
              corporationId: 0,
              corporateEventArchive: 0
//                status: '1',
//                 chatroll_event_id: 7,
//                 eventId: 0,
            },
            experts: [],
            corporations: [],
            type: [{name:'Select Type'}, {id:1, name:'Live Event'}, {id:2, name:'Talk Event'}, {id:3, name:'Corporation Self-Hosted Event'}],
            status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            eventType: [{name:'Select'}, {id:1, name:'Private'}, {id:0, name:'Public'}],
            rules: {
                title: {required : true, min: 5},
                description: {required : true, min : 15},
                longDescription: {required : true, min : 15},
                duration: {required : true},
                img_url: {required: true},
                tags: {required: true},
              csvExpertsIds: {required: true},
                authBanner: {required: true},
                unAuthBanner: {required: true},
//                jw_rtmp_url: {required: true},
                chatroll_event_name: {required: false},
                type: {required: true},
                status: {required: true},
                isPrivate: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            res.unshift({name: "Select an option"});
            this.corporations = res;
            console.log("this.corporations : ", this.corporations);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        previewThumbnail: function(event) {
            console.log("event : ", event);
            let input = event.target;
            console.log("input : ", input);

            if (input.files && input.files[0]) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.newImage = e.target.result;
                }
                reader.readAsDataURL(input.files[0]);
                this.event.img_url = input.files[0];
            }
        },
        createEvent () {
            let startDate = new Date(this.startDate).getTime();
            let endDate = new Date(this.endDate).getTime();
            console.log("moment(startDate).format('MM/DD/YYYY h:mm:ss') : ", moment(startDate).format('MM/DD/YYYY H:mm:ss'));
            console.log("moment(endDate).format('MM/DD/YYYY h:mm:ss') : ", moment(endDate).format('MM/DD/YYYY H:mm:ss'));
            if(endDate < startDate){
                this.showPopup('Error!', 'Event End Date must be greater then start Date.', 'error')
            }
            /*else if(!this.event.img_url){
             this.showPopup('Error!', 'Event Image is not selected', 'error')
             }*/
            else{
                this.$validator.validateAll().then((result) => {
                    if(result){
                        console.log("this.event : ", this.event);
                        this.event.start_date =  moment(startDate).format('MM/DD/YYYY H:mm:ss');
                        this.event.end_date =  moment(endDate).format('MM/DD/YYYY H:mm:ss');

                        /*this.$store.dispatch('TOGGLE_LOADING', true);
                         imageHelpers.upload({
                         data: this.event.img_url,
                         file: this.newImage[0],
                         }, (err, res) => {
                         console.log("imageHelpers.upload err : ", err);
                         console.log("imageHelpers.upload res : ", res);
                         if(res){
                         this.event.img_url = res.Location;*/

                        console.log('event to be created', this.event)
                        this.event.csvExpertsIds = this.event.csvExpertsIds.toString()
                        this.$store.dispatch('ADD_EVENT', {event: this.event, file: this.newImage[0]})
                                .then((res) => {
                                    console.log("ADD_EVENT res : ", res);
                                    if(res) this.showPopup('Success!', 'Event is successfully created', 'success', ()=>this.$router.push('/admin/events'))
                                    else this.showPopup('Error!', 'Unable to process.', 'error')
                                })
                                .catch(err => {
                                    this.showPopup('Error!', 'Event name is already created.', 'error')
                                    console.log("ADD_EVENT API error : ", err);
                                })

                        /*}
                         else this.$store.dispatch('TOGGLE_LOADING', false);

                         });*/
                    }
                })
            }
            console.log("this.event : ", this.event);
        },
        fetchExperts () {
            this.$store.dispatch('FETCH_EXPERTS')
                    .then((res) => {
                        res.unshift({name: "Select an option"});
                        this.experts = res;
                        console.log("this.experts : ", this.experts);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    }),
                    (err) => {
                        console.log("err : ", err);
                    }
        },
        updateValue(data){
            /*imageHelpers.upload(data.path, (err, res) => {
             console.log("imageHelpers.upload err : ", err);
             console.log("imageHelpers.upload res : ", res);
             this.newImage = data.path;
             this.event.img_url = data.value;
             });*/
            this.event.img_url = data.path;
            this.newImage = data.value;
            console.log("updateValue data : ", data);
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {
        this.fetchExperts();
        this.fetchCorporations();
    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Events/CreateEvent.vue